import React from 'react';
import { I18n } from 'react-redux-i18n';
import SelectWineVintage from 'components/Select/selectWineVintage';
import { Competitor } from 'interface/price';

const PricesEvolutionSelectCompetitors = ({
  competitors,
  vintage,
  setCompetitors,
  showVintages,
  rivals
}: {
  competitors: Competitor[];
  vintage: string | null;
  showVintages: boolean;
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  setCompetitors: (e: any) => void;
  rivals: any[];
}) => {
  // If showVintage is false we need to filter competitors by the current vintage and keep only this one
  const filteredRivals = showVintages
    ? rivals
    : rivals
        .filter((rival: any) => rival.vintages.includes(vintage))
        .map((rival: any) => ({ ...rival, vintages: [vintage] }));

  const vintagesByWine = Object.assign(
    {},
    ...filteredRivals.map((rival: any) => ({
      [rival.wine_id]: { name: rival.wine_name, vintages: rival.vintages }
    }))
  );

  const onChange = (value: any) => {
    setCompetitors(value);
  };

  return (
    <div className="selectSetsContainer ignored-export">
      <SelectWineVintage
        onChange={onChange}
        value={competitors}
        vintagesByWine={vintagesByWine}
        showVintages={showVintages}
        isMulti={true}
        placeholder={I18n.t('prices.evolution.placeholderRivals')}
      />
    </div>
  );
};

export default PricesEvolutionSelectCompetitors;
